import React from 'react'

import { Input, Select, DatePicker, Row, Col, Button, Tag} from 'antd'

import moment from 'moment'

const { Option } = Select;

const options = {
    name: 'NAME',
    user: 'USER',
    fromdate: 'FROM',
    todate: 'TO'
}

class DocumentSearch extends React.Component {

    constructor (props){
        super();
        this.props = props;
        this.state = {
            selectedOption: 'name',
            name: null,
            todate: null,
            fromdate: null,
            user: null,
            searched: [],
        }
    }

    search =  async () => {

        const criteria = {
            searchtxt: this.state.name,
            uploadedBy: this.state.user,
            todate: this.state.todate,
            fromdate: this.state.fromdate
        }
        await this.props.onSearch(criteria);

        const searched = Object.keys(options).map( option => {
            if ( this.state[option] ){
                return {option: option, value: this.state[option]}
            }
        }).filter( e => { return e !== undefined } );

        this.setState({searched: searched})
    }

    renderInputElements = (value)=>{

        let comp = <Input style={{width: '100%'}} value={this.state.name} allowClear onPressEnter={ this.search} onChange={(e) => {
            this.setState({name: e.target.value})
        }}/>;

        switch (value){
            case 'uploadedAt':
                comp = (<Row type="flex">
                            <Col span={12}> <DatePicker style={{ width: '100%' }} value={this.state.fromdate} onChange={(date) =>{
                                this.setState({fromdate: date})
                            }}/> </Col>
                            <Col span={12}> <DatePicker style={{ width: '100%' }} value={this.state.todate} onChange={(date) =>{
                                this.setState({todate: date})
                            }}/> </Col>
                        </Row>);
                break;
            case 'uploadedBy':
                comp = <Input style={{ width: '100%' }} value={this.state.user} allowClear onPressEnter={ this.search} onChange={(e) => {
                    this.setState({user: e.target.value})
                }} />
                break;

        }

        return comp;
    }

    onCloseTag = (option) => {
        let state = {};
        state[option] = null;
        const filtered = this.state.searched.filter( e => { return e.option !== option })
        state.searched = filtered;
        this.setState(state);
    }

    onClearAll = () => {
        this.setState({fromdate: null, todate: null, user: null, name: null, selectedOption: 'name', searched: []});
        this.props.onSearch(null);
    }

    renderTags = (searched) => {
        const tags = searched.map( s => {
            let value = s.value;
            const option = s.option;
            if (value instanceof moment){
                value = value.format().substr(0,10)
            }
            if (value ) {
                const label = options[option];
                return ( <Tag key={option} closable onClose={() => {
                    this.onCloseTag(option)
                }}>
                    {label} : {value.toString()}
                </Tag> )
            }
        });
        if ( tags.length > 0) {
            tags.push(<Tag key={'clearAll'} closable onClose={() => {
                this.onClearAll()
            } }> CLEAR ALL</Tag>)
        }
        return tags;
    }

    render() {
        const tags = this.renderTags(this.state.searched);

        return (
            <div style={{width:'100%'}}>
               <Row type="flex">
                    <Col style={{width: '90px'}} >
                        <Select value={this.state.selectedOption} style={{width: '100%'}} onChange={
                            value => {
                                this.setState({selectedOption:value});
                            }
                        }>
                            <Option value="name">Name</Option>
                            <Option value="uploadedAt">Date</Option>
                            <Option value="uploadedBy">User</Option>
                        </Select>
                    </Col>
                    <Col span={8}>
                        {this.renderInputElements(this.state.selectedOption)}
                    </Col>
                    <Col>
                        <Button icon="search" onClick={this.search}> </Button>
                    </Col>
               </Row>
                <br/>
                <Row>
                    {tags}
                </Row>
                { (tags.length > 0) && <br/> }
            </div>
        )
    }
}
export default DocumentSearch;
